import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

import { rootRouteRef } from './routes';

const apiGovernanceEntityTab = EntityContentBlueprint.make({
  name: 'api-governance',
  params: {
    path: '/governance',
    title: 'Governance',
    filter: 'kind:api',
    routeRef: rootRouteRef,
    loader: async () => {
      const { ApiGovernanceContent } = await import(
        './components/ApiGovernanceContent'
      );
      return <ApiGovernanceContent />;
    },
  },
});

export const apiGovernancePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'api-governance-frontend',
  extensions: [apiGovernanceEntityTab],
  routes: {
    root: rootRouteRef,
  },
});
